export const DEFAULT_NEWS_PAGE_SIZE = 5;
export const DEFAULT_NEWS_PAGE_NUMBER = 1;
export const MAX_SYMBOLS_PER_REQUEST_LIMIT = 15;
